import Input from '../../../../../components/Input/Input';
import SelectClientIssuer from '../../../../../components/Selects/SelectClientDocumentType';
import { colors } from '../../../../../constants/colors';
import { phone as PHONE_MASK } from '../../../../../constants/mask';
import { textStyles } from '../../../../../constants/textStyles';
import { fieldDomId, formatField, issuerOption } from './form';

export const card = {
  background: '#fafafa',
  border: '1px solid #eee',
  borderRadius: 8,
  padding: '16px 20px',
  marginBottom: 16,
};
export const grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(200px, 1fr))',
  gap: 16,
  alignItems: 'end',
};
export const termsGrid = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 16,
};
export const title = { ...textStyles.formTitle, fontSize: 16, marginBottom: 14 };
export const hint = { color: colors.dimGray, fontSize: 14, lineHeight: '20px', margin: '0 0 12px' };
export const area = {
  width: '100%',
  boxSizing: 'border-box',
  padding: 12,
  border: '1px solid #d9d9d9',
  background: '#fff',
  font: 'inherit',
  resize: 'vertical',
};

export const Fields = ({ fields, section, form, isError, onChange }) =>
  fields.map((field) => {
    const id = fieldDomId(`${section}.${field.key}`);
    if (field.type === 'issuer') {
      return (
        <div key={field.key} id={id}>
          <SelectClientIssuer
            label={field.label}
            value={issuerOption(form?.[section]?.[field.key])}
            error={isError(section, field.key)}
            handleSetState={(opt) => onChange(section, field.key, opt?.value != null ? String(opt.value) : '')}
          />
        </div>
      );
    }
    return (
      <Input
        key={field.key}
        id={id}
        label={field.label}
        type={field.type}
        placeholder={field.placeholder}
        mask={field.kind === 'phone' ? PHONE_MASK : undefined}
        maxLength={field.kind === 'iban' ? 20 : field.kind === 'bic' ? 11 : undefined}
        value={form?.[section]?.[field.key] || ''}
        error={isError(section, field.key)}
        handleSetState={(next) => onChange(section, field.key, formatField(field.kind, next))}
      />
    );
  });

export const Banner = ({ tone, children }) => {
  const palettes = {
    warn: { background: '#FFF4E5', color: '#8A5300' },
    ok: { background: '#EAF7ED', color: '#1E6B2E' },
    err: { background: '#FDEDED', color: '#9B1C1C' },
    info: { background: '#F4F4F4', color: colors.dimGray },
  };
  return (
    <div style={{ padding: '12px 16px', borderRadius: 8, marginBottom: 20, ...palettes[tone] }}>
      {children}
    </div>
  );
};
